<template>
  <div
    class="app-container"
    style="min-height: calc(100vh - 136px)"
    v-loading="homeLoading"
    :element-loading-text="$t('拼命加载中')"
  >
    <div>
      <!-- 操作栏 -->
      <div class="text-bold flex-x-center flex-sub">
        <div class="title--newFont">{{ $t("委外订单详情") }}</div>
        <!-- 按钮 -->
        <div style="text-align: right">
          <el-button size="small" class="btnTwo" @click="backHome">{{
            $t("返回")
          }}</el-button>
        </div>
      </div>
      <hr />
      <div style="color: #08a1b8; font-weight: 800; font-size: 16px; margin-top: 10px">
        丨{{ $t("基本信息") }}
      </div>
      <!-- 内容 -->
      <div>
        <el-descriptions
          class="margin-top"
          size="small"
          :column="5"
          border
          :label-style="labelStyle"
          :contentStyle="{ width: '220px' }"
        >
          <el-descriptions-item>
            <template slot="label">{{ $t("委外单号") }} </template>
            <span>{{ hostData.outsourcingDocNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("全局搜索码") }} </template>
            <span>{{ hostData.globalSearchNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("客户订单号") }} </template>
            <span>{{ hostData.baseCustomerSalesOrderNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外开始时间") }}</template>
            <span>{{ hostData.baseOutsourcingStartTime }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("交货日期") }}</template>
            <span>{{ formatDate(hostData.valueOutsourcingDeliveryDate) }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> {{ $t("委外商") }} </template>
            <span>{{ hostData.baseOutsourcingSupplierName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> {{ $t("负责人") }} </template>
            <span>{{ hostData.baseOutsourcingChargemanName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("其他费用") }}</template>
            <span>{{ hostData.baseOtherTotalprice }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("成品仓库") }}</template>
            <span>{{ hostData.baseOutsorWarehouseName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("原料仓库") }}</template>
            <span>{{ hostData.baseRawmaterialWarehouseName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> {{ $t("优先级") }} </template>
            <span>{{ hostData.priorityLevel }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("付款模式") }}</template>
            {{ hostData.paymentMode }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外金额") }}</template>
            {{ hostData.baseMaterialTotalprice }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> {{ $t("备注") }} </template>
            <span>{{ hostData.remark }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="color: #08a1b8; font-weight: 800; font-size: 16px; margin-top: 10px">
        丨{{ $t("产品信息") }}
      </div>
      <myTable
        style="margin-top: 10px"
        :id="'bill_one'"
        :columnType="'columnIndex'"
        :list="mainProductList"
        :titleList="mainProductTitleList"
        :tableBtnList="[]"
        @cellClickEvent="mainProductClickEvent"
        :dialogStatus="1"
        ref="myTableOne"
      >
      </myTable>
      <div style="color: #08a1b8; font-weight: 800; font-size: 16px; margin-top: 10px">
        丨{{ $t("物料信息") }}
      </div>
      <myTable
        style="margin-top: 10px"
        ref="myTable"
        :columnType="'columnIndex'"
        :list="list"
        :titleList="titleList"
        :tableBtnList="tableBtnList"
        @cellClickEvent="mainProductClickEvent"
        :dialogStatus="1"
      ></myTable>
    </div>
  </div>
</template>
<script>
import { outsourcingDoc_view } from "@/api/myController/outsourcing";
import {
  selcetSetting,
  updateSetting,
  divFloat,
  mulFloat,
  readUserSelect,
} from "@/utils/myUtils";
export default {
  components: {},
  props: {
    // 页面传进来判断入库的值
    routeType: {
      type: Array,
      default: undefined,
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({}),
    },
  },
  data() {
    return {
      homeLoading: false,
      // 标签页
      activeName: "first",
      // 页面传输数据
      hrefProData: {},
      // 主表数据
      hostData: {},
      // 页面显示able数据
      list: [],
      titleList: [
        {
          id: 1,
          name: this.$t("物料图片"),
          value: "baseImgUrl",
          fixedState: false,
          isShow: true,
          dataType: "image",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 95,
        },
        {
          id: 0,
          name: this.$t("物料图纸"),
          value: "baseDrawingFile",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 60,
        },
        {
          id: 0,
          name: this.$t("物料附件"),
          value: "baseFileList",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 60,
        },
        {
          name: this.$t("物料编号"),
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          color: "#049eff",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 120,
        },
        {
          id: 1,
          name: this.$t("物料名称"),
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "customTable",
          alwaysEditState: false,
          canEdit: false,
          width: 120,
        },
        {
          id: 2,
          name: this.$t("规格"),
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          alwaysEditState: false,
          canEdit: false,
          width: 180,
        },
        {
          id: 2,
          name: this.$t("客户料号"),
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 180,
        },
        {
          id: 8,
          name: this.$t("需求数量"),
          value: "valueMaterialQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          alwaysEditState: false,
          canEdit: false,
          width: 90,
        },
        {
          id: 7,
          name: this.$t("单位"),
          value: "baseMaterialUnitName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 90,
        },
        {
          id: 11,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
        },
      ],
      // dialog数据
      dialogState: {
        show1: false,
        show2: false,
        show3: false,
        show4: false,
      },
      globalSearchDialogData: {},
      materialNumberDialogData: {},
      // *************主表状态
      labelStyle: {
        "text-align": "center",
        "font-weight": "600",
        "min-width": "110px",
        "word-break": "keep-all",
        height: "41px",
      },
      mainProductList: [],
      // 主产品
      mainProductTitleList: [
        {
          id: 1,
          name: this.$t("产品图片"),
          value: "baseImgUrl",
          fixedState: false,
          isShow: true,
          dataType: "image",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 95,
        },
        {
          id: 0,
          name: this.$t("产品图纸"),
          value: "baseDrawingFile",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 60,
        },
        {
          id: 0,
          name: this.$t("产品附件"),
          value: "baseFileList",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 60,
        },
        {
          id: 0,
          name: this.$t("订单图片"),
          value: "valueImgList",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 60,
        },
        {
          id: 0,
          name: this.$t("订单附件"),
          value: "valueFileList",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 60,
        },
        {
          name: this.$t("产品编号"),
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          color: "#049eff",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 120,
        },
        {
          id: 1,
          name: this.$t("产品名称"),
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "customTable",
          alwaysEditState: false,
          canEdit: false,
          width: 120,
        },
        {
          id: 2,
          name: this.$t("规格"),
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          alwaysEditState: false,
          canEdit: false,
          width: 180,
        },
        {
          id: 2,
          name: this.$t("客户料号"),
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 180,
        },
        {
          id: 4,
          name: this.$t("单价"),
          value: "baseMaterialUnitprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          alwaysEditState: false,
          canEdit: false,
          width: 60,
        },
        {
          id: 8,
          name: this.$t("委外数量"),
          value: "baseOutsourcingQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          alwaysEditState: false,
          canEdit: false,
          width: 90,
        },
        {
          id: 7,
          name: this.$t("单位"),
          value: "baseMaterialUnitName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 90,
        },
        {
          id: 9,
          name: this.$t("委外金额"),
          value: "baseMaterialTotalprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 90,
        },
        {
          id: 11,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
        },
      ],
      // --------------------文件上传
      singleRowData: {},
      tableList: [],
      dialogType: 1,
      dialogStatus: 1,
      dialogTitle: "",
      markIndex: 1,
      //
      processesList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 多语言
    $t(value) {
      return value;
    },
    getList() {
      this.homeLoading = false;
      outsourcingDoc_view({
        outsourcingDocId: this.routeQuery.outsourcingDocId,
      }).then((res) => {
        if (res.data.data.baseProcessIdlist) {
          res.data.data.baseProcessIdlist = JSON.parse(res.data.data.baseProcessIdlist);
        }
        try {
          let modelCtrl = JSON.parse(res.data.data.modelCtrl);
          res.data.data.modelCtrls = parseFloat(modelCtrl.STATEMENT_TYPE);
        } catch (error) {}
        // 处理主表
        try {
          if (res.data.data.sysDocExtVo) {
            this.sysEntityExtDto = res.data.data.sysDocExtVo;
          } else {
            this.sysEntityExtDto = {};
          }
        } catch (error) {
          this.sysEntityExtDto = {};
        }
        res.data.data.modelCtrlss = "";
        res.data.data.outsourcingDocMaterials.forEach((item) => {
          try {
            item.specifications = JSON.parse(item.baseMaterialSpecDesc);
          } catch (error) {
            item.specifications = [];
          }
          item.materialId = item.baseMaterialId;
          item.specGroupId = item.baseMaterialSpecgroupId;
          item.baseMaterialQuantity = divFloat(
            item.valueMaterialQuantity,
            res.data.data.baseOutsourcingQuantity
          );
        });
        this.homeLoading = false;
        this.hostData = res.data.data;
        this.hostData.baseOutsourcingQuantity = this.hostData.baseOutsourcingQuantity;
        try {
          this.hostData.specifications = JSON.parse(this.hostData.baseMaterialSpecDesc);
        } catch (error) {}
        this.mainProductList = [this.hostData];
        this.list = res.data.data.outsourcingDocMaterials;
      });
    },
    customSelectDataShow(val, list) {
      if (list) {
        let single = list.filter((item) => {
          return item.value == val;
        });
        return single.length > 0 ? single[0].label : "";
      }
    },
    specListShow(list) {
      let text = "";
      try {
        for (let i = 0; i < list.length; i++) {
          let kong = i == list.length - 1 ? "" : "/";
          text += list[i].specKey + ":" + list[i].specValue + kong;
        }
      } catch (error) {}
      return text;
    },
    mainProductClickEvent(row, column) {
      switch (column.title) {
        default:
          break;
      }
    },
    formatDate(time) {
      return this.$moment(time).format("YYYY-MM-DD"); // 获取当前时间
    },
    backHome() {
      this.$emit("backHome");
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
/*  */
.spanBtn {
  color: #08a1b8;
  font-size: 14px;
  cursor: pointer;
  width: 96px;
  text-align: center;
  line-height: 30px;
  float: left;
}

.tableContentTitle {
  height: 32px;
  line-height: 32px;
  background-color: #f8f8f9;
  font-size: 12px;
  margin-top: 10px;
  border: 1px solid #e8eaec;
  border-bottom: 0;
  padding-left: 40px;
}

.tableContent {
  width: 99%;
  margin: 0px auto;
  table-layout: fixed;
  word-wrap: break-word;
  border-collapse: collapse;
  font-size: 12px;
  border-left: 1px solid #e8eaec;
}

.tableContent td {
  height: 34px;
  background-color: #ffffff;
  border: 1px solid #e8eaec;
  border-left: 0px;
  color: black;
  text-align: center;
  padding-left: 4px;
}

.tableTitle {
  width: 99%;
  margin: 0 auto;
  table-layout: fixed;
  word-wrap: break-word;
  border-collapse: collapse;
  font-size: 14px;
  border-left: 1px solid #e8eaec;
}

.tableTitle td {
  height: 34px;
  background-color: #f8f8f9;
  border: 1px solid #e8eaec;
  border-left: 0px;
  color: black;
  text-align: center;
  padding-left: 4px;
}

.td_center {
  text-align: center;
}

//
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
        justify-content:center; */
}

.title----font {
  color: rgb(8, 161, 184);
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.input {
  width: 180px;
  margin-right: 20px;
}

.btnOne {
  background: #08a1b8;
  color: white;
  margin-right: 20px;
}
</style>
